import React from 'react';
import { Clock, Loader, CheckCircle, XCircle, RefreshCw } from 'lucide-react';

export const ProgressSteps = ({ currentStep, isProcessing, hasError }) => {
  const isRetrying = currentStep === 'retrying';

  const steps = [
    { key: 'pending', label: '等待处理', icon: Clock },
    { key: 'processing', label: isRetrying ? '切换渠道重试中' : '处理中', icon: isRetrying ? RefreshCw : Loader },
    { key: 'completed', label: hasError ? '处理失败' : '处理完成', icon: hasError ? XCircle : CheckCircle }
  ];

  const getStepIndex = (step) => {
    if (step === 'pending') return 0;
    if (step === 'processing' || step === 'retrying') return 1;
    if (step === 'completed' || step === 'failed' || step === 'timeout') return 2;
    return 0;
  };

  const currentStepIndex = getStepIndex(currentStep);

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const Icon = step.icon;
          const isActive = index === currentStepIndex && (currentStep === 'pending' || currentStep === 'processing' || isRetrying);
          const isCompleted = index < currentStepIndex || (index === currentStepIndex && currentStep === 'completed' && !hasError);
          const isFailed = hasError && index === currentStepIndex && (currentStep === 'failed' || currentStep === 'timeout' || currentStep === 'completed');
          
          return (
            <div key={step.key} className="flex items-center flex-1">
              <div className="flex flex-col items-center">
                <div className={`flex items-center justify-center w-8 h-8 rounded-full border-2 transition-all duration-300 ${
                  isFailed 
                    ? 'bg-red-100 border-red-500 text-red-600' 
                    : isRetrying && index === currentStepIndex
                      ? 'bg-amber-100 border-amber-500 text-amber-600'
                      : isCompleted 
                        ? 'bg-green-100 border-green-500 text-green-600'
                        : isActive 
                          ? 'bg-indigo-100 border-indigo-500 text-indigo-600' 
                          : 'bg-slate-100 border-slate-300 text-slate-400'
                }`}>
                  {isActive && (isProcessing || isRetrying) && (step.key === 'processing') ? (
                    <Icon className="w-4 h-4 animate-spin" />
                  ) : (
                    <Icon className="w-4 h-4" />
                  )}
                </div>
                <span className={`text-xs mt-1 transition-all duration-300 ${
                  isFailed 
                    ? 'text-red-600 font-medium' 
                    : isRetrying && index === currentStepIndex
                      ? 'text-amber-600 font-medium'
                      : isCompleted
                        ? 'text-green-600 font-medium'
                        : isActive 
                          ? 'text-indigo-600 font-medium' 
                          : 'text-slate-400'
                }`}>
                  {step.label}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div className={`flex-1 h-0.5 mx-4 transition-all duration-300 ${
                  index < currentStepIndex || (index === currentStepIndex - 1 && currentStep === 'completed' && !hasError) 
                    ? 'bg-green-500' 
                    : 'bg-slate-200'
                }`}></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};